import { ShortUrl } from '@air/api';
import { BatchUpdateFormAssetsInput } from '@air/api/types';
import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { contentCollectionFormSelector, contentCollectionShortIdSelector } from '../redux';

export const useBatchUpdateFormAssetsMutation = () => {
  const form = useSelector(contentCollectionFormSelector);
  const shortId = useSelector(contentCollectionShortIdSelector);

  return useMutation({
    mutationFn: (data: BatchUpdateFormAssetsInput) => {
      if (!shortId) {
        throw new Error('No shortId');
      }

      if (!form?.id) {
        throw new Error('No form id');
      }

      return ShortUrl.batchUpdateFormAssets(shortId, form.id, data);
    },
  });
};
